module.exports = __webpack_public_path__ + "img/team4.8ec7811f.png";